import { render } from "./TheFooter.pug?vue&type=template&id=ec9dffc4&lang=pug"
import script from "./TheFooter.js?vue&type=script&lang=js"
export * from "./TheFooter.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__